// extracted by mini-css-extract-plugin
module.exports = {"iconContainer":"C3dJqV","icon":"_1ZRVic","rightArrowSmall":"_2tavC8"};